<div class="page">
    <div class="hero landing-hero" #hero>
        <h1 class="hero__title">The screening tool</h1>
        <div class="c-tabs desktop-only">
            <div class="tab" [ngClass]="{'tab--active' : activeTab === ScreeningTabEnum.Introduction}">Introduction
                <div class="tab__hotspot" (click)="changeTab(ScreeningTabEnum.Introduction)"></div>
                <div class="shadow" *ngIf="activeTab !== ScreeningTabEnum.Introduction"></div>
            </div>
            <div class="tab" [ngClass]="{'tab--active' : activeTab === ScreeningTabEnum.StartScreening, 'tab--start-screening' : activeTab === ScreeningTabEnum.StartScreening && !hasResults}">Start screening
                <div class="tab__hotspot" (click)="changeTab(ScreeningTabEnum.StartScreening)"></div>
                <div class="shadow" *ngIf="activeTab !== ScreeningTabEnum.StartScreening"></div>
            </div>
            <div class="tab" [ngClass]="{'tab--active' : activeTab === ScreeningTabEnum.Feedback}">Feedback
                <div class="tab__hotspot" (click)="changeTab(ScreeningTabEnum.Feedback)"></div>
                <div class="shadow" *ngIf="activeTab !== ScreeningTabEnum.Feedback"></div>
            </div>
        </div>
    </div>
    <app-introduction *ngIf="activeTab === ScreeningTabEnum.Introduction"></app-introduction>
    <app-start-screening *ngIf="activeTab === ScreeningTabEnum.StartScreening"></app-start-screening>
    <ng-container *ngIf="activeTab === ScreeningTabEnum.Feedback">
        <app-feedback></app-feedback>
    </ng-container>
</div>
